<template>
  <default-layout>
    <template slot="top">
      <h1 class="mt-1 title">Annales</h1>
    </template>
    <template slot="left">
      <left-side-bar-bottom :view-annales="true">
        <template slot="annales">
          <div class="subject-list mb-1">
            <ul class="">
              <li :class="{active: subject_id===null}" @click="subject_id=null">Toutes les matières</li>
              <li :class="{active: subject_id===subject.id}" v-for="subject in subjects" @click="subject_id=subject.id">
                {{ subject.name }}
              </li>
            </ul>
          </div>
        </template>
      </left-side-bar-bottom>
    </template>
    <template slot="center">
      <div class="white-card" style="min-height: 300px">
        <div class="d-flex justify-content-between flex-column flex-md-row">
          <h3 class="title">Epreuves</h3>
          <div class="search-form">
            <button><i class="ti-search"></i></button>
            <input type="text" placeholder="Rechercher une epreuve"
                   class=" shadow-none form-control" v-model="search">
            <button @click="search=''"><i class="ti-close"></i></button>
          </div>
          <select v-model="subject_id" class="form-control d-block d-md-none mt-2" name="subjects" id="">
            <option :value="null">Toutes les matières</option>
            <option v-for="subject in subjects" :value="subject.id">
              {{ subject.name }}
            </option>
          </select>
        </div>
        <div class="pb-5 mt-3">
          <div class="loader mt-4" v-if="loading"></div>
          <exam-item v-if="!loading" v-for="exam in exams" :key="exam.id" :exam="exam"></exam-item>
          <template v-if="!loading && exams.length===0">
            <p class="text-green text-center mt-5">
              Aucune epreuve disponible
            </p>
          </template>
        </div>
      </div>
    </template>
  </default-layout>
</template>
<script>
import ExamItem from "@/components/Exam/ExamItem";
import axios from "axios";
import LeftSideBarBottom from "@/components/LayoutPartials/LeftSideBarBottom";
import {mapGetters} from "vuex";
import DefaultLayout from "@/Layout/DefaultLayout";
import _ from 'lodash'

export default {
  name: "ExamList",
  components: {
    DefaultLayout,
    LeftSideBarBottom,
    ExamItem
  },
  data() {
    return {
      page: 1,
      items: 10,
      loading: false,
      search: '',
      exams: [],
      subject_id: null
    }
  },
  computed: {
    ...mapGetters({
      'subjects': 'subject/subjects'
    })
  },
  watch: {
    search: _.debounce(function (newVal) {
      // ne pas faire la recherche si le champ ne contient pas au moins 2 caractères et n'est pas vide
      if (newVal.length > 0 && newVal.length < 2) return
      this.loadData()
    }, 300),
    subject_id() {
      this.loadData()
    }
  },
  methods: {
    loadData() {
      this.loading = true
      axios.get('/exam', {params: {search: this.search, subject_id: this.subject_id}})
        .then(({data}) => {
          this.exams = data.data
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  mounted() {
    this.loadData()
    this.$store.dispatch('subject/fetchClassroomSubjects')
  }
}
</script>
<style lang="scss" scoped>
.subject-list {
  padding: 5px;
  background-color: #FAFAFA;

  ul {
    li {
      padding: 5px;
      text-align: center;
      cursor: pointer;

      &:not(:last-child) {
        border-bottom: 1px solid #aaa;
      }
    }
  }

}

.search-form {
  display: flex;
  background: lighten($gray, 30);
  border: 2px solid $gray;
  border-radius: 10px;
  padding: 0 15px;

  > * {
    border: none;
    background-color: transparent;
    line-height: 30px;
    @include no-outline();
  }

  input {
    flex-grow: 1;
  }

  button {
    padding: 0;

    i {
      vertical-align: middle;
      width: 16px;
      height: 16px;
    }
  }
}
</style>
